import { SET_HEADER_LOGO } from './constants';

export function setHeaderLogo(logo) {
  return {
    type: SET_HEADER_LOGO,
    payload: { logo },
  };
}
